<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="actionBar">
        学员名字：
        <el-input
          class="searchInput"
          size="small"
          placeholder="学员名字"
          v-model="searchCondition.userName"
          clearable
        >
        </el-input
        >&emsp; 学员手机：
        <el-input
          class="searchInput"
          size="small"
          placeholder="学员手机"
          v-model="searchCondition.mobile"
          clearable
        >
        </el-input
        >&emsp;开题报告标题：
        <el-input
          class="searchInput"
          size="small"
          placeholder="开题报告标题"
          v-model="searchCondition.reportName"
          clearable
        >
        </el-input
        >&emsp;
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="getData()"
          >查询
        </el-button>
      </div>

      <div class="tableContainer">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column type="selection" width="40px"> </el-table-column>
          <el-table-column prop="userName" label="学员姓名" width="120px">
          </el-table-column
          ><el-table-column prop="mobile" label="手机号" width="240px">
          </el-table-column
          ><el-table-column prop="reportName" label="开题报告标题">
          </el-table-column
          ><el-table-column prop="createTime" label="上传时间">
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="{ row, index }">
              <el-button plain size="mini" class="bluBar" @click="pdfShow(row)"
                >预览
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->

        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="getData"
                @current-change="getData"
                :current-page.sync="searchCondition.jumpPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size.sync="searchCondition.pageSize"
                layout="prev, pager, next"
                :total="searchCondition.total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl" v-if="pdfData.pdfIfShow"></pdf-preview>
    </el-dialog>
  </div>
</template>

<script>
import { getOpenQuestionReportList } from "@/api/paper.js";
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";

export default {
  data() {
    return {
      searchCondition: {
        total: 0,
        jumpPage: 1,
        pageSize: 10,
        userName: "",
      },
      dataList: [],
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
    };
  },
  computed: {},
  watch: {},
  components: { pdfPreview },

  methods: {
    getData() {
      getOpenQuestionReportList(this.searchCondition).then((data) => {
        console.log(data);
        this.dataList = data.records;
        this.searchCondition.total = data.total;
      });
    },
    pdfShow(row) {
      this.pdfData.pdfUrl = row.openQuestionReport;
      this.pdfData.pdfIfShow = true;
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;

  .contentBox {
    background: #fff;
    padding: 20px;

    .actionBar {
      .searchInput {
        width: 20%;
      }

      .saveBar {
        display: inline-block;
        float: right;
      }
    }

    .tableContainer {
      background: #fff;
      padding-top: 20px;
    }

    /deep/ .el-table {
      //   background-color: #000;
      border-bottom: 1px;
    }
  }
}
</style>
